var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-chart-container"},[_c('LineChartComponent',{attrs:{"data":_vm.chartData,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }